import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, TextButton } from '@wix/design-system';
import { ArrowLeftSmall } from '@wix/wix-ui-icons-common';
import s from './BackToExplorer.module.scss';

const BackToExplorer: FC<{ showBack: boolean; isMobileView?: boolean }> = ({
  showBack,
  isMobileView,
}) => {
  const { t } = useTranslation();

  if (!showBack) return null;

  return (
    <Box
      dataHook="back-to-explorer"
      className={`${s.backToExplorer} ${isMobileView ? s.mobile : ''}`}
    >
      <TextButton
        onClick={() => {
          history.back();
        }}
        size="small"
        skin="dark"
        prefixIcon={<ArrowLeftSmall />}
      >
        {t('back-to-explorer-back')}
      </TextButton>
    </Box>
  );
};

export default BackToExplorer;
